export const initClientTableData = ({
  clientRowData
}) => {

  return clientRowData.map(client => {
    const {
      band,
      rssi
    } = client;

    const formattedSignal = band && rssi ? `${band}/${rssi} %` : null;

    return {
      ...client,
      formattedMacAddress: client.clientId,
      formattedSignal,
    }
  })

}

export const getClientsSendRequestParams = ({ auth, infoData }) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiKey = `${apiBaseUrl}/sites/:siteId/devices/:deviceId/clients.read`;
  const deviceId = infoData.id;

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: infoData.siteId,
      deviceId,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
      deviceId,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiKey,
    restfulParams
  };
}